import EventEmitter from 'events';
import TypedEmitter from 'typed-emitter';
import file from '../../../../common/file';

type Events = {
  open: (file: file, viewer: HTMLDivElement) => void;
  close: (file: file) => void;
};

interface supportedFormatsItem {
  extension: string;
  icon?: string;
}

interface supportedFormats {
  items: supportedFormatsItem[];
  add: (extension: string, icon?: string) => void;
  remove: (extension: string) => void;
  get: (extension: string) => supportedFormatsItem | undefined;
}

const supportedFormats: supportedFormats = {
  items: [] as supportedFormatsItem[],
  add: function (extension: string, icon?: string) {
    this.items.push({ extension, icon });
  },
  remove: function (extension: string) {
    this.items = this.items.filter((e) => e.extension !== extension);
  },
  get: function (extension: string) {
    return this.items.find((e) => e.extension === extension);
  },
};

class FileViewer extends (EventEmitter as new () => TypedEmitter<Events>) {
  supportedFormats: supportedFormats;
  constructor() {
    super();
    this.supportedFormats = supportedFormats;
  }
}

export default FileViewer;
